export default function StatusIndicator({ level = 'loading', size = 'large' }) {
  const sizes = { small: { outer: 40, inner: 32 }, large: { outer: 80, inner: 64 } };
  const colours = {
    online: { outer: '#22C55E', inner: '#86EFAC', shadow: '0 0 20px rgba(34,197,94,.5)' },
    warning: { outer: '#F59E0B', inner: '#FCD34D', shadow: '0 0 20px rgba(245,158,11,.5)' },
    offline: { outer: '#EF4444', inner: '#FCA5A5', shadow: '0 0 20px rgba(239,68,68,.5)' },
    loading: { outer: '#6B7280', inner: '#9CA3AF', shadow: '0 0 20px rgba(107,114,128,.35)' }
  };
  const dimensions = sizes[size] || sizes.large;
  const colour = colours[level] || colours.loading;

  return (
    <div style={{
      width: dimensions.outer,
      height: dimensions.outer,
      borderRadius: '50%',
      backgroundColor: colour.outer,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: colour.shadow,
      animation: level === 'warning' ? 'pulse 2s infinite' : 'none',
      margin: '0 auto'
    }}>
      <div style={{
        width: dimensions.inner,
        height: dimensions.inner,
        borderRadius: '50%',
        backgroundColor: colour.inner,
        opacity: 0.8
      }} />
    </div>
  );
}
